// lodash
import get from 'lodash/get';
import filter from 'lodash/filter';
//
import { getCookie } from '../cookie/cookie';
import { isPactApp, isApps } from '../../redux/reducers/app/appReducer';
import loginTypeConstants from '../../constants/loginTypeConstants';

function getPactCookieValues(state) {
  if (isPactApp(state)) {
    return {
      pactStoreNumber: getCookie('store_branch_number'),
      pactPEDDeviceId: getCookie('store_ped_id'),
    };
  }

  return {};
}

const getMvtFeatures = (state) => {
  const features = get(state, 'config.features', []);
  const mvtFeatures = filter(features, feature => feature.source === 'MVT');
  return mvtFeatures.reduce((acc, feature) => ({ ...acc, [feature.id]: feature.enabled ? 'on' : 'off' }), {});
};

export function stringifyObject(object = {}) {
  return JSON.stringify(object);
}

export function setUserInformationToNewRelic(state) {
  if (window.newrelic && window.newrelic.setCustomAttribute) {
    const sessionId = get(state, 'bff.sessionId', '');
    const isPactOrder = isPactApp(state);
    const isAppOrder = isApps(state);
    const isGuest = get(state, 'user.isGuest');

    let loginType = get(state, 'login.loginType');
    if (isPactOrder) {
      loginType = loginTypeConstants.PACT_APPS;
    }

    if (isAppOrder) {
      loginType = loginTypeConstants.CUSTOMER_APPS;
    }

    const customerSessionAttributes = stringifyObject({
      ...getPactCookieValues(state),
      ...getMvtFeatures(state),
    });

    // booleans must be sent as strings
    window.newrelic.setCustomAttribute('sessionId', sessionId);
    window.newrelic.setCustomAttribute('isPactOrder', `${isPactOrder}`);
    window.newrelic.setCustomAttribute('isGuest', `${isGuest}`);
    window.newrelic.setCustomAttribute('customerSessionAttributes', `${customerSessionAttributes}`);
    window.newrelic.setCustomAttribute('loginType', loginType);
  }
}

export function sendNewRelicCustomEvent(actionName, attributes) {
  if (window.newrelic && window.newrelic.addPageAction) {
    window.newrelic.addPageAction(actionName, attributes);
  }
}

export function createNewRelicTrackingObject() {
  if (window.newrelic && window.newrelic.interaction) {
    return window.newrelic.interaction();
  }
  return false;
}

export function saveNewRelicTrackingEvent(trackingObject) {
  if (trackingObject) {
    trackingObject.save();
  }
}

export function endNewRelicTrackingEvent(trackingObject) {
  if (trackingObject) {
    trackingObject.end();
  }
}

export function setCorrelationIdToNewRelic(id) {
  if (window.newrelic && window.newrelic.interaction) {
    const newRelicInteraction = window.newrelic.interaction();
    newRelicInteraction.setAttribute('correlationId', id);
  }
}

export const reportErrorToNewRelic = ({ error, errorDescription, options = {} }) => (dispatch, getState) => {
  if (window.newrelic && window.newrelic.noticeError) {

    const sessionId = get(getState(), 'bff.sessionId');
    const timestamp = Date.now();
    const { pathname } = window.location;
    const { userAgent } = window.navigator;

    const params = {
      timestamp,
      path: (pathname || '').replace(/(\?.*)|(#.*)/g, ''),
      userAgent,
      sessionId,
      errorDescription,
      ...options,
    };

    window.newrelic.noticeError(error, params);
  }
};

export const initLogging = () => (dispatch, getState) => {
  setUserInformationToNewRelic(getState());
  return dispatch({ type: 'INIT_LOGGING' });
};
